<template>
  <div>
    <vx-card>
      <div class="flex pb-5 justify-between items-center">
        <!-- description -->
        <div>
          {{ description }}
        </div>
      </div>

      <vs-table :data="_notificationPaymentSchedules">

        <template slot="thead">
          <vs-th>{{ $t("sections.accounting.dataForm.no") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.loan.agingNumber") }}</vs-th>
          <vs-th>ยอดเรียกเก็บค้างชำระ</vs-th>
          <vs-th>ยอดเรียกเก็บปัจจุบัน</vs-th>
          <vs-th>ต่าธรรมเนียม</vs-th>
          <vs-th>เบี้ยปรับ</vs-th>
          <vs-th>วันที่นัดชำระ</vs-th>
          <vs-th>จำนวน</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index"
                 v-for="({paymentDate, paymentAmount, loan}, index) in data">
            <vs-td>
              {{ index + 1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id: loan.contract.id}}">
                {{ loan.contract.contractNo }}
                <b><u>{{ loan.contract.contractSeq }}</u></b></router-link>
            </vs-td>
            <vs-td>
              <div style="display: flex; align-items: center;">
                <span>{{ loan.contract.contractName }}</span>
              </div>
            </vs-td>
            <vs-td>
              {{ loan.agingNumber }}
            </vs-td>
            <vs-td>
              {{ loan.outstandingAmountRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.outstandingBalanceRemain - loan.outstandingAmountRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.accruedFeeRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.accruedPenaltyRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ paymentDate | convYYYYMMDDToDDMMYYYY }}
            </vs-td>
            <vs-td>
              {{ paymentAmount | numberFormat }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider} from "vee-validate";
import {createNamespacedHelpers, mapState} from 'vuex'
import CustomPopup from '@/views/components/custom/Popup'
import {IStatus} from "@/constants/interface";

const {mapActions: mapNotificationActions, mapState: mapNotificationState} = createNamespacedHelpers('Notification')

export default {
  components: {
    CustomPopup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {}
  },
  async created() {
    await this.loadNotificationPaymentSchedules();
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapNotificationState(['status', 'notificationPaymentSchedules']),
    IStatus() {
      return IStatus
    },
    _notificationPaymentSchedules: function () {
      if (this.notificationPaymentSchedules.length > 0) {
        return this.notificationPaymentSchedules
      }
      return this.notificationPaymentSchedules
    },
    description: function () {
      const vm = this
      return `รายการทั้งหมด ${vm._notificationPaymentSchedules.length} รายการ`
    }
  },
  methods: {
    ...mapNotificationActions(['getNotificationPaymentSchedules']),
    async loadNotificationPaymentSchedules() {
      const vm = this
      const {getNotificationPaymentSchedules} = vm;
      await getNotificationPaymentSchedules({
        action: vm.$route.params.action,
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
